import React from 'react';
import { ColorArray } from '../../ColorArray';
import { useTextColor } from '../../../LeftWorkArea/LeftWorkColor/useTextColor';
import { colors } from '../../../../constants/utils';

export const SettingsColor = ()=>{
    const{changeColor, color} = useTextColor(colors);

    return <ColorArray defaultColor={color} onColorSelected={changeColor}/>
}